<template>
  <div class="container">
    <table class="table table-striped" style="border: 1px solid #000;">
      <thead>
        <tr>
          <th scope="col" colspan="2">Variables</th>
          <th scope="col">{{ Yeartwo }}</th>
          <th scope="col">{{ YearOne }}</th>
          <th scope="col">{{ varEntorno }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th scope="row" colspan="2">{{ textOne }}</th>
          <td>
            <input
              class="input"
              :disabled="readOnly"
              v-model="porcentajeIngreso.inputOne"
            />
          </td>
          <td>
            <input
              :disabled="readOnly"
              class="input"
              v-model="porcentajeIngreso.inputThree"
            />
          </td>
          <td>
            <input
              :disabled="readOnly"
              v-model="porcentajeIngreso.inputFive"
              class="input"
            />
          </td>
        </tr>
        <tr>
          <th scope="row" colspan="2">{{ textTwo }}</th>
          <td>
            <input
              :disabled="readOnly"
              v-model="porcentajeIngreso.inputTwo"
              class="input"
            />
          </td>
          <td>
            <input
              :disabled="readOnly"
              v-model="porcentajeIngreso.inputFour"
              class="input"
            />
          </td>
          <td>
            <input
              :disabled="readOnly"
              v-model="porcentajeIngreso.inputSix"
              class="input"
            />
          </td>
        </tr>
        <tr>
          <th scope="row" colspan="2">{{ textThree }}</th>
          <td>
            <div v-if="inputOne === '' || inputTwo === ''">
              <span>--</span>
            </div>
            <div v-else>
              <span>{{ intPorcentajeOne }}%</span>
            </div>
          </td>
          <td>
            <div v-if="inputThree === '' || inputFour === ''">
              <span>--</span>
            </div>
            <div v-else>
              <span>{{ intPorcentajeTwo }}%</span>
            </div>
          </td>
          <td>
            <div v-if="inputFive === '' || inputSix === ''">
              <span>--</span>
            </div>
            <div v-else>
              <span>{{ intPorcentajeThree }}%</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
// import store from "../../../../../store";
export default {
  props: ["porcentajeIngreso", "readOnly"],
  data() {
    return {
      textOne:
        "(a) N° de ingresos a la contrata  año t vía proceso de reclutamiento y selección.",
      textTwo: "(b) Total de ingresos a la contrata año t",
      textThree:
        "Porcentaje ingresos a la contrata con proceso de reclutamiento y selección (a/b)",
      varEntorno: `${process.env.VUE_APP_ANIO}`,
      YearOne: "",
      Yeartwo: "",
      YearThre: "",
      data: "1",
      dataTwo: "2",
      porcentajeOne: "",
      porcentajeTwo: "",
      porcentajeThree: "",
      porcentaje: "100",
      intPorcentajeOne: null,
      intPorcentajeTwo: null,
      intPorcentajeThree: null,
      arrayFather: null,
    };
  },

  mounted() {
    this.YearOne = parseInt(this.varEntorno) - parseInt(this.data);
    this.Yeartwo = parseInt(this.varEntorno) - parseInt(this.dataTwo);
    // this.arrayFunction();
  },
  updated() {
    // Primer porcentaje
    this.porcentajeOne =
      (parseInt(this.porcentajeIngreso.inputOne) /
        parseInt(this.porcentajeIngreso.inputTwo)) *
      parseInt(this.porcentaje);
    this.intPorcentajeOne = this.porcentajeOne.toFixed(2);

    //Segundo Porcentaje
    this.porcentajeTwo =
      (parseInt(this.porcentajeIngreso.inputThree) /
        parseInt(this.porcentajeIngreso.inputFour)) *
      parseInt(this.porcentaje);
    this.intPorcentajeTwo = this.porcentajeTwo.toFixed(2);

    //Tercer Porcentaje
    this.porcentajeThree =
      (parseInt(this.porcentajeIngreso.inputFive) /
        parseInt(this.porcentajeIngreso.inputSix)) *
      parseInt(this.porcentaje);
    this.intPorcentajeThree = this.porcentajeThree.toFixed(2);

    // store.dispatch("rHumanos/actionsTable", {
    //   value: [
    //     {
    //       title: this.textOne,
    //       anioTwo: this.inputOne,
    //       anioOne: this.inputThree,
    //       anio: this.inputFive,
    //     },
    //     {
    //       title: this.textTwo,
    //       anioTwo: this.inputTwo,
    //       anioOne: this.inputFour,
    //       anio: this.inputSix,
    //     },
    //     {
    //       title: this.textThree,
    //       anioTwo: this.intPorcentajeOne,
    //       anioOne: this.intPorcentajeTwo,
    //       anio: this.intPorcentajeThree,
    //     },
    //   ],
    //   nameTable: "porcentajeIngreso",
    // });
  },
};
</script>

<style scoped>
th {
  text-align: left !important;
  font-size: 14px !important ;
}
</style>
